// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2IZQq","info":"UpdateTermsInfo_info__2xh1Y"};